import { FileFetchingDetails, IntegrationData, PlatformIntegrationData } from "../Integrations.types"
import {
	integrationListCVList,
	integrationGetCVContent,
	integrationGetUserDetails,
} from "shared/src/libs/apiLib/apiLib"

export const bhClientId = "eb61e86f-2689-4dc2-a5b0-3906b736c171"

export const bullhornIntegrationData: PlatformIntegrationData<
	"oauthLogin" | "setupUser" | "candidateProfile" | "chooseFile" | "fetchFile" | "confirmationPage"
> = {
	allowChat: true,
	parameterMapping: {
		clientId: "client_id",
		externalClientId: "CorporationID",
		externalId: "EntityID",
		userId: "UserID",
	},
	pages: ["oauthLogin", "setupUser", "candidateProfile", "chooseFile", "fetchFile", "confirmationPage"],
	props: {
		oauthLogin: {
			newTab: false,
			createStateData: ({ sig, integrationData, clientId }) => ({ sig, integrationData, clientId }),
			getLoginUrl: (integrationData: IntegrationData, state?: string) => {
				const stateQueryString = state ? `&state=${encodeURIComponent(state)}` : ""
				return `https://auth.bullhornstaffing.com/oauth/authorize?client_id=${bhClientId}&response_type=code&redirect_uri=${window.location.origin}/oauthcallback${stateQueryString}`
			},
		},
		setupUser: {
			getUserDetails: async (clientId: string, integrationData: IntegrationData) => {
				return await integrationGetUserDetails(integrationData, clientId)
			},
		},
		fetchFile: {
			getFile: async (clientId: string, integrationData: IntegrationData, fileFetchingDetails: FileFetchingDetails) => {
				return await integrationGetCVContent(integrationData, fileFetchingDetails, clientId)
			},
		},
		chooseFile: {
			listFiles: async (clientId: string, integrationData: IntegrationData) => {
				return await integrationListCVList(integrationData, clientId)
			},
		},
		confirmationPage: {},
		candidateProfile: {},
	},
	initialData: {},
	useFrontendFileUpload: false,
}
